<template>
    <div class="data-evaluation-page">
        <!-- 数据表字段详情 -->
        <el-card class="box-card" shadow="never">
            <div slot="header" class="clearfix">
                <span>数据完整分析</span>
            </div>
            <el-row :gutter="20">
                <el-col :span="3">
                    <div style="margin-bottom: 10px;">
                        数据文件上传：
                    </div>
                </el-col>
                <el-col :span="9">
                    <!-- 上传区域 -->
                    <el-upload ref="upload" drag action='#' :auto-upload="false" :on-change="handleAnalysisFileChange"
                        :on-remove="handleRemove" :file-list="analysisFileList" :limit="10" :multiple="true"
                        :show-file-list="false" accept=".xlsx">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">点击或拖拽文件到此处<br>
                            <span style="color: gray; font-size: 10px;">
                                支持 Excel(.xlsx) 文件格式 文件大小不得超过{{ fileSizeLimit }}M</span>
                        </div>
                    </el-upload>
                </el-col>
                <el-col :span="12">
                    <el-row :gutter="20" style="min-height: 170px">
                        <p>已选择文件:</p>
                        <div v-if="analysisFileList.length > 0" style="max-height: 130px; overflow-y: auto;">
                            <el-table :data="analysisFileList" style="width: 100%" border>
                                <el-table-column prop="name" label="文件名" width="300">
                                    <template slot-scope="scope">
                                        <span style="display: flex; align-items: center;">
                                            <i :class="getFileTypeIcon(scope.row.name)" style="margin-right: 8px;"></i>
                                            {{ scope.row.name }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="size" label="大小" width="120">
                                    <template slot-scope="scope">
                                        {{ formatFileSize(scope.row.size) }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="状态" width="150">
                                    <template slot-scope="scope">
                                        <el-progress v-if="scope.row.percentage < 100 && scope.row.status !== 'success'"
                                            :percentage="scope.row.percentage" :show-text="false"
                                            :stroke-width="6"></el-progress>
                                        <el-tag v-else-if="scope.row.status === 'success'" type="success"
                                            size="small">上传完成</el-tag>
                                        <el-tag v-else-if="scope.row.status === 'error'" type="danger"
                                            size="small">上传失败</el-tag>
                                        <el-tag v-else type="info" size="small">待上传</el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" width="80">
                                    <template slot-scope="scope">
                                        <el-button type="text" @click="removeAnalysisFile(scope.$index)"
                                            :disabled="scope.row.status === 'uploading'">
                                            删除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div v-else
                            style="display: flex; align-items: center; justify-content: center; color: #909399;">
                            暂无文件
                        </div>
                    </el-row>
                    <el-row :gutter="20" type="flex" justify="center">
                        <el-button :disabled="analysisFileList.length === 0"
                            @click="clearAnalysisFiles">清空列表</el-button>
                        <el-button type="primary" @click="startUploadAnalysis" :loading="analysisUploading"
                            :disabled="analysisFileList.length === 0 || analysisUploading">
                            {{ analysisUploading ? '上传中...' : '上传' }}
                        </el-button>
                    </el-row>
                </el-col>
            </el-row>
        </el-card>

        <!-- 分析结果显示区域 -->
        <el-card class="box-card result-card" shadow="never" v-if="analysisResults.length > 0">
            <div slot="header" class="clearfix">
                <span>分析结果</span>
                <el-button style="float: right; padding: 3px 0" type="text" @click="clearResults">清空结果</el-button>
            </div>
            <div class="result-content">
                <el-table :data="analysisResults" style="width: 100%" border>
                    <el-table-column prop="fileName" label="文件名" width="200"></el-table-column>
                    <el-table-column prop="result" label="分析结果">
                        <template slot-scope="scope">
                            <div class="result-text">{{ scope.row.result }}</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-card>

    </div>
</template>

<script>
export default {
    name: 'DataQualityApply',
    data() {
        return {
            fileSizeLimit: 50, // 文件大小限制，单位MB
            analysisFileList: [], // 存储需要上传的文件列表
            analysisUploading: false, // 是否正在上传文件
            allAnalysisUploaded: false,
            registrationId: '',
            userId: '',
            analysisResults: [], // 存储分析结果
        }
    },
    created() {
        // 从路由中获取传递的参数
        this.registrationId = this.$route.query.registrationId || '';
        this.userId = this.$route.query.userId || '';

        if (this.registrationId && this.userId) {
            this.initializeApplication();
        }
    },
    methods: {
        initializeApplication() {
            this.getRequest('/web/dataQualityDetail/query?registrationId=' + this.registrationId).then(resp => {
                if (resp.data) {
                    console.log(resp.data);
                }
            }).catch(error => {
                console.error('获取数据失败:', error);
            });
        },
        // 处理文件选择的方法
        handleAnalysisFileChange(file, fileList) {
            // 校验文件类型
            const isExcel = file.name.endsWith('.xlsx');
            if (!isExcel) {
                this.$message.error('仅支持 .xlsx 文件格式！');
                // 从fileList中移除不符合条件的文件
                const index = fileList.indexOf(file);
                if (index > -1) {
                    fileList.splice(index, 1);
                }
                return;
            }

            // 校验文件大小
            const isLtLimit = file.size / 1024 / 1024 < this.fileSizeLimit;
            if (!isLtLimit) {
                this.$message.error(`上传文件大小不能超过 ${this.fileSizeLimit}MB！`);
                // 从fileList中移除不符合条件的文件
                const index = fileList.indexOf(file);
                if (index > -1) {
                    fileList.splice(index, 1);
                }
                return;
            }
            this.analysisFileList = fileList;
        },
        // 处理删除文件的方法
        removeAnalysisFile(index) {
            this.analysisFileList.splice(index, 1);
        },
        // 清空文件列表的方法
        clearAnalysisFiles() {
            this.analysisFileList = [];
        },
        // 清空分析结果
        clearResults() {
            this.analysisResults = [];
        },
        // 开始上传文件
        startUploadAnalysis() {
            if (this.analysisFileList.length === 0) {
                this.$message.warning('请先选择文件');
                return;
            }

            this.analysisUploading = true;
            // 清空之前的分析结果
            this.analysisResults = [];

            // 逐个上传文件
            const uploadPromises = this.analysisFileList.map((file, index) => {
                // 更新文件状态为上传中
                this.$set(this.analysisFileList[index], 'status', 'uploading');
                this.$set(this.analysisFileList[index], 'percentage', 0);

                // 调用自定义上传方法
                return new Promise((resolve, reject) => {
                    const customOptions = {
                        file: file.raw || file,
                        index: index, // 传递文件索引
                        onProgress: (event) => {
                            this.$set(this.analysisFileList[index], 'percentage', event.percent);
                        },
                        onSuccess: (response, fileName) => {
                            this.$set(this.analysisFileList[index], 'status', 'success');
                            // 处理分析结果
                            this.handleAnalysisResult(response, file.name);
                            resolve(response);
                        },
                        onError: (error) => {
                            this.$set(this.analysisFileList[index], 'status', 'error');
                            // 添加错误结果
                            this.analysisResults.push({
                                fileName: file.name,
                                result: '分析失败: ' + (error.message || '服务器错误')
                            });
                            reject(error);
                        }
                    };
                    this.customUpload(customOptions, 'dataFieldFile');
                });
            });

            // 等待所有文件上传完成
            Promise.all(uploadPromises)
                .then(() => {
                    this.analysisUploading = false;
                    this.allAnalysisUploaded = true;
                    this.$message.success('所有文件分析完成');
                })
                .catch(() => {
                    this.analysisUploading = false;
                    this.$message.error('部分文件分析失败');
                });
        },
        // 处理分析结果
        handleAnalysisResult(response, fileName) {
            if (response && response.status === 200) {
                const resultData = response.data;
                let resultText = '';
                
                // 根据返回数据的结构提取结果
                if (typeof resultData === 'string') {
                    resultText = resultData;
                } else if (resultData.object) {
                    resultText = resultData.object;
                } else if (resultData.data) {
                    resultText = resultData.data;
                } else if (resultData.result) {
                    resultText = resultData.result;
                } else {
                    resultText = JSON.stringify(resultData);
                }
                
                this.analysisResults.push({
                    fileName: fileName,
                    result: resultText
                });
            } else {
                this.analysisResults.push({
                    fileName: fileName,
                    result: '分析失败: ' + (response.msg || '未知错误')
                });
            }
        },
        // 获取文件图标
        getFileTypeIcon(filename) {
            const ext = filename.split('.').pop().toLowerCase();
            if (ext === 'xlsx') return 'el-icon-document';
            if (ext === 'docx') return 'el-icon-document';
            return 'el-icon-document';
        },
        // 格式化文件大小
        formatFileSize(size) {
            if (size < 1024) return size + ' B';
            if (size < 1024 * 1024) return (size / 1024).toFixed(1) + ' KB';
            return (size / 1024 / 1024).toFixed(1) + ' MB';
        },
        // 移除文件
        handleRemove(file, fileList) {
            this.analysisFileList = fileList;
        },
        // 自定义上传逻辑
        customUpload(options, fileType) {
            const { file, onProgress, onSuccess, onError } = options;

            // 创建表单数据
            const formData = new FormData();
            formData.append('registrationId', this.registrationId);
            formData.append('type', fileType);
            formData.append('file', file);

            // 发送上传请求
            this.$axios.post('/web/excel/analysis/queryEmpty', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: (progressEvent) => {
                    const percentCompleted = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total
                    );
                    onProgress({ percent: percentCompleted }, file);
                }
            }).then(response => {
                if (response.status === 200) {
                    onSuccess(response, file.name);
                } else {
                    onError(new Error(response.msg || '文件上传失败'));
                }
            }).catch(error => {
                onError(error);
            });
        }
    }
}
</script>

<style scoped>
.data-evaluation-page {
    padding: 15px;
    background-color: #f5f5f5;
}

.box-card {
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
}

.box-card>>>.el-card__header {
    background-color: #f0f0f0;
    font-weight: bold;
    font-size: 16px;
    color: #333;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both;
}

.result-text {
    white-space: pre-wrap; /* 保持换行符 */
    word-break: break-all; /* 长单词或长字符串换行 */
    font-family: 'Courier New', monospace; /* 等宽字体，适合显示文本结果 */
    line-height: 1.6;
    padding: 5px 0;
}
</style>